import { Box, Center } from '@chakra-ui/react';
import { format } from 'date-fns';
import ko from 'date-fns/locale/ko';
import React from 'react';
import ChatMessage from './ChatMessage';

interface ChatMessageBubbleProps {
  chatRoom: any;
  message: any;
  previousMessage?: any;
  myLastUnSeenMessage?: any;
  isFirstMessage: boolean;
  styleVariant?: 'default' | 'trading';
}

const dateBoxStyles = {
  default: {
    borderRadius: '30px',
    fontSize: '12px',
    fontWeight: 500,
    padding: '6px 12px'
  },
  trading: {
    borderRadius: '30px',
    fontSize: '12px',
    fontWeight: 500,
    padding: '6px 12px'
  }
};

export default function ChatMessageBubble({
  chatRoom,
  message,
  previousMessage,
  myLastUnSeenMessage,
  isFirstMessage,
  styleVariant = 'default'
}: ChatMessageBubbleProps): JSX.Element {
  // 안전하게 메시지가 존재하는지 확인
  if (!message || !message.sentAt) {
    return <div />;
  }

  const currentDate = new Date(message.sentAt);
  const previousDate = previousMessage && previousMessage.sentAt ? new Date(previousMessage.sentAt) : null;

  // 날짜 헤더를 표시할지 결정 - 첫 번째 메시지이거나 이전 메시지와 날짜가 다른 경우
  const shouldShowDateHeader = isFirstMessage ||
    (previousDate && format(previousDate, 'P', { locale: ko }) !== format(currentDate, 'P', { locale: ko }));

  const dateBoxStyle = dateBoxStyles[styleVariant];

  return (
    <div key={message.chatRoomMessageId}>
      {shouldShowDateHeader && (
        <>
          {styleVariant === 'default' ? (
            <div className="flex justify-center mb-3">
              <div className="text-main-light-4 dark:text-main-dark-4 bg-surface-light dark:bg-surface-dark rounded-[30px] text-xs font-medium px-3 py-1.5">
                {format(currentDate, 'PPP', { locale: ko })}
              </div>
            </div>
          ) : (
            <Center marginBottom={'12px'}>
              <Box
                className="text-main-light-4 dark:text-main-dark-4 bg-[rgba(0, 0, 0, 0.06)] dark:bg-[rgba(18, 18, 18, 0.1)]"
                style={dateBoxStyle}
              >
                {format(currentDate, 'PPP', { locale: ko })}
              </Box>
            </Center>
          )}
        </>
      )}
      <div className={styleVariant === 'default' ? 'pb-3' : ''} style={styleVariant === 'trading' ? { paddingBottom: '12px' } : {}}>
        <ChatMessage
          key={message.chatRoomMessageId}
          chatRoom={chatRoom}
          message={message}
          isLastUnSeenMessage={myLastUnSeenMessage === message}
        />
      </div>
    </div>
  );
}
